<template>
  <v-container
    ><h3 class="mb-2 mt-3 d-none d-md-flex">My Ticket</h3>
    <p>Semua event yang kamu ikuti</p>
    <v-skeleton-loader type="card" :loading="loading">
      <v-card v-if="data.length <= 0" flat class="mb-3 mt-16">
        <div class="d-flex justify-center flex-column align-center fill-height">
          <v-img
            src="../assets/illustration/not-found.svg"
            max-width="280"
            max-height="280"
            contain
          />
          <p class="text-center mt-5">
            Unch, kamu belum punya tiket event apapun. Ikuti dulu yuk event nya
          </p>
        </div>
      </v-card>
      <v-card v-else outlined v-for="(item, i) in data" :key="i" class="mb-3">
        <div class="d-flex flex-no-wrap justify-space-between">
          <div>
            <v-card-text v-if="item.is_paid == 0" class="pb-0"
              ><v-chip color="warning" small
                >Menunggu Pembayaran</v-chip
              ></v-card-text
            >
            <v-card-text v-else-if="item.is_paid == 3" class="pb-0"
              ><v-chip color="red" small>Kadaluarsa</v-chip></v-card-text
            >
            <v-card-title class="title">{{ item.event_title }}</v-card-title>
            <v-card-subtitle>
              <div>{{ item.event_date }} {{ item.event_time }}</div>
              <div>{{ item.event_place }}</div>
            </v-card-subtitle>
          </div>
          <v-avatar class="ma-3" size="80" tile>
            <v-img :src="item.cover"></v-img>
          </v-avatar>
        </div>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <div>Ticket {{ item.ticket_name }}</div>
              <div class="font-weight-bold orange--text">
                {{ item.ticket_price }}
              </div>
            </v-col>
            <v-col cols="6">
              <div>ID Transaksi</div>
              <div class="font-weight-bold orange--text">
                {{ item.code }}
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn :to="/my-ticket/ + item.id" text color="primary" block
            >Lihat Detail</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-skeleton-loader>
  </v-container>
</template>

<script>
import Axios from 'axios';

export default {
  name: 'MyTicket',
  data() {
    return {
      loading: true,
      data: [],
      error: false,
      errorMessage: null,
      token: 'Bearer ' + localStorage.getItem('token'),
      user: JSON.parse(localStorage.getItem('user')),
    };
  },
  mounted() {
    Axios.get(process.env.VUE_APP_API + 'my-ticket/', {
      headers: {
        Authorization: this.token,
      },
    })
      .then((response) => {
        this.data = response.data.data;
      })
      .catch((error) => {
        this.error = true;
        this.errorMessage = error;
      })
      .finally(() => (this.loading = false));
  },
  metaInfo() {
    return {
      title: 'My Ticket',
      titleTemplate: '%s - Eventversity',
      htmlAttrs: {
        lang: 'id',
        amp: true,
      },
    };
  },
};
</script>

<style scoped></style>
